/**
 * Master App Configuration
 *
 * This file contains all the configurable values for the app.
 * When creating a new app from this scaffold, update these values
 * to customize the app for your specific use case.
 */
import { Capacitor } from "@capacitor/core";

// ===========================================
// APP IDENTITY & BRANDING
// ===========================================
export const APP_IDENTITY = {
  // App display names
  name: "Keep On Tugging",
  shortName: "KOT",
  description: "A one-stop tracking app for restoration",
  tagline: "Building community among restorers",

  // Package identifiers (MUST be unique for each app)
  packageId: "com.keepontugging.kot",
  bundleId: "com.keepontugging.kot", // iOS bundle identifier

  // Demo/test user credentials
  demoUserId: "6d6uUgIUyFSO055Fmmqw1nk1R1L2",
  demoUsername: "AttackTitan",
};

// ===========================================
// WEB & DOMAIN CONFIGURATION
// ===========================================
export const WEB_CONFIG = {
  // Primary domain and URLs
  domain: "keepontugging.com",
  homepage: "https://keepontugging.com/",

  // Contact information
  email: "keepontugging@gmail.com",
  feedbackForm: "https://forms.gle/dB54KwqFvMaCkKpW9",

  // SEO & Meta
  themeColor: "#2296f3",
  backgroundColor: "#ffc107",

  // Default route for new users
  defaultRoute: "tug",
};

// ===========================================
// MOBILE STORE LINKS
// ===========================================
export const STORE_LINKS = {
  ios: "https://apps.apple.com/us/app/kot-keep-on-tugging/id6751866502",
  android:
    "https://play.google.com/store/apps/details?id=com.keepontugging.kot",
  website: "https://keepontugging.com",
};

// ===========================================
// FIREBASE CONFIGURATION
// ===========================================
export const FIREBASE_CONFIG = {
  // Firebase project settings
  projectId: "keep-on-tugging",
  authDomain: "keep-on-tugging.firebaseapp.com",
  databaseURL: "https://keep-on-tugging.firebaseio.com",
  storageBucket: "keep-on-tugging.appspot.com",

  // API keys and IDs
  apiKey: "AIzaSyD0awJF1u_zCwpE4NC6AO1Yn9f5K0neAcg",
  messagingSenderId: "316297455897",
  appId: "1:316297455897:web:73581993b50f983876fd88",
  measurementId: "G-RQM4184F2H",

  // Hosting URL
  site: null,

  // Remote Config defaults
  remoteConfigDefaults: {
    gatekeep: false,
    latest_version: 1000000,
    price: 14.99,
  },
};

// ===========================================
// ADMOB CONFIGURATION
// ===========================================
export const ADMOB_CONFIG = {
  // Publisher ID (same across platforms)
  publisherId: "ca-pub-2469164274354307",

  // Platform-specific app and ad unit IDs
  ios: {
    appId: "ca-app-pub-2469164274354307~5127254812",
    bannerId: "ca-app-pub-2469164274354307/2791347425",
  },
  android: {
    appId: "ca-app-pub-2469164274354307~1816146335",
    bannerId: "ca-app-pub-2469164274354307/3909260071",
  },
  web: {
    appId: "ca-app-pub-2469164274354307~1816146335", // Default to Android for web
    bannerId: "ca-app-pub-2469164274354307/3909260071",
  },
};

// ===========================================
// ===========================================
// UI/UX THEME CONFIGURATION
// ===========================================
export const THEME_CONFIG = {
  basename: "",
  defaultPath: "",
  fontFamily: "'Inter', sans-serif",
  borderRadius: 24,
  gridSpacing: 3,
  drawerWidth: 260,
  appDrawerWidth: 320,
  nativeStatusBarHeight: Capacitor.isNativePlatform() ? 35 : 0,
  toolbarHeight: 50 + (Capacitor.isNativePlatform() ? 35 : 0),
};
